import { format0 } from 'utils/number';
import { parseMomentUtc } from 'utils/dates';

export const dash = (value: string | number | null | undefined): string => {
  if (value === null || value === undefined) return '—';
  return String(value);
};

export const num = (value: number | null | undefined): string =>
  format0(value, '—');

// Parsed as UTC so date-only timestamps (published/first/last used) keep their
// calendar day regardless of the ambient timezone.
export const date = (iso: string | null | undefined): string => {
  if (!iso) return '—';
  const m = parseMomentUtc(iso);
  return m.isValid() ? m.format('MMM D, YYYY') : iso;
};
